var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeadphone2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21 19.758a.881.881 0 0 1-.876-.875v-6.65c-.058-3.161 1.12-6.148 3.313-8.388C5.841 1.617 8.781.392 11.942.392c6.464 0 11.725 5.261 11.725 11.725v6.65a.881.881 0 0 1-.875.875.881.881 0 0 1-.875-.875v-6.65c0-5.495-4.468-9.975-9.975-9.975-2.695 0-5.191 1.038-7.046 2.928-1.867 1.902-2.859 4.433-2.812 7.14v6.662c0 .49-.385.886-.875.886z",
    fill: "#0044EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93 12.525H4.78A4.451 4.451 0 0 0 .334 16.97v2.193a4.451 4.451 0 0 0 4.445 4.445h.152a4.451 4.451 0 0 0 4.445-4.445V16.97a4.451 4.451 0 0 0-4.445-4.445zM19.222 12.525h-.152a4.451 4.451 0 0 0-4.445 4.445v2.193a4.451 4.451 0 0 0 4.445 4.445h.152a4.451 4.451 0 0 0 4.445-4.445V16.97a4.451 4.451 0 0 0-4.445-4.445z",
    fill: "#0044EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeadphone2);
export default __webpack_public_path__ + "static/media/icon_headphone_2.bb3fcb447dfe62bf9695db32e7a16602.svg";
export { ForwardRef as ReactComponent };